import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {IServerResponse} from '@interfaces/server';
import {take, takeUntil} from 'rxjs/operators';
import moment from 'moment';
import {LocalStorageDecorator} from 'src/app/libs/local-storage-decorator';
import {FazerPedidoService} from '@services/fazer-pedido.service';
import {Router} from '@angular/router';
import {IPedidoEstoquePapelResponse} from '@interfaces/pedido-estoque-papel';
import {ReplaySubject, Subject} from 'rxjs';
import {EnderecoValePapel} from '@interfaces/endereco-vale-papel';
import {ProdutoValePapel} from '@interfaces/produto-vale-papel';
import { EMAIL_REGEX } from '@utils/html-sanitizer.util';
import { WindowReferenceService } from '@services/window-reference.service';
import { AlertConcluirPedidoEstoquePapelComponent } from '../../components/alert-concluir-pedido-estoque-papel/alert-concluir-pedido-estoque-papel.component';
import { HeaderComponent } from '../../components/header/header.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { AlertaExclusaoBeneficioComponent } from './alerta-exclusao-beneficio/alerta-exclusao-beneficio.component';
import { AlertErroPadraoComponent } from '../../components/alert-erro-padrao/alert-erro-padrao.component';
import { AlertDescartarAlteracoesComponent } from '../../components/alert-descartar-alteracoes/alert-descartar-alteracoes.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { MatFormField, MatLabel, MatPrefix, MatError, MatSuffix } from '@angular/material/form-field';
import { NgClass, AsyncPipe } from '@angular/common';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatSelectSearchComponent } from 'ngx-mat-select-search';
import { MatInput } from '@angular/material/input';
import { SelectComponent } from '../../components/select/select.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { DateMaskDirective } from '../../directives/date-mask.directive';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepickerToggleIcon, MatDatepicker } from '@angular/material/datepicker';
import { MatIcon } from '@angular/material/icon';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
    selector: 'app-pedido-estoque-papel',
    templateUrl: './pedido-estoque-papel.component.html',
    styleUrls: ['./pedido-estoque-papel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AlertConcluirPedidoEstoquePapelComponent, HeaderComponent, LoadingGenericoComponent, BotaoChatComponent, AlertaExclusaoBeneficioComponent, AlertErroPadraoComponent, AlertDescartarAlteracoesComponent, BreadcrumbComponent, FormsModule, ReactiveFormsModule, MatFormField, NgClass, MatLabel, MatPrefix, MatSelect, MatOption, MatSelectSearchComponent, MatError, MatInput, SelectComponent, NgxPaginationModule, DateMaskDirective, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatIcon, MatDatepickerToggleIcon, MatDatepicker, FooterComponent, AsyncPipe]
})
export class PedidoEstoquePapelComponent implements OnInit {
  @LocalStorageDecorator('idEmpresaLogada', false) idEmpresaLogada;
  formData = new FormData();
  alertConcluirPedido = false;
  checkForm = false;
  loadingGenerico = false;
  beneficioEncontrado = true;
  emailConfirmacaoError = false;
  emailNfError = false;
  emailNf2Error = false;
  showAlertConfirmaPedido = false;
  showAlertErro = false;
  resumoPedidoProcessado = false;
  dataPagamentoError = false;
  temErro = false;
  contatoSelecionado: any;
  enderecoSelecionado: any;
  contatoSelecionadoError: boolean = false;
  enderecoFaturamentoError: boolean = false;
  idImportacaoError: boolean = false;
  campoEmailErrorMessage: string = 'Formato de e-mail inválido';
  campoEmailNfErrorMessage: string;
  campoEmailNf2ErrorMessage: string;
  idEndereco: any;
  idProduto: any = 0;
  idEnderecoFaturamento: any = 0;
  idContatoFaturamento: any = 0;
  searchTextFilterBenefits: any;
  emailConfirmacao: any;
  botaoErroBeneficio: any;
  mensagemErroBeneficio: any;
  tituloMensagemErroBeneficio: any;
  searchTextFilter: any;
  dataPagamentoMessageError: any;
  idImportacao: any;
  detalhePedido: any;
  emailNf: any;
  emailNf2: any;
  benefitList = [];
  listaBeneficiosVerificacao = [];

  enderecosFaturamento = [];
  beneficiosEncontrados = [];
  enderecosCadastrados: ReplaySubject<EnderecoValePapel[]> = new ReplaySubject<EnderecoValePapel[]>(1);
  produtosCadastrados: ReplaySubject<ProdutoValePapel[]> = new ReplaySubject<ProdutoValePapel[]>(1);
  enderecoControle: UntypedFormControl = new UntypedFormControl(null);
  enderecosRecuperados = false;
  contatosCadastrados = [];
  form2DefaultValues = {
    dtPagamento: null,
    enderecoFaturamento: '',
    contatoFaturamento: '',
    emailConfirmacao: '',
    emailNF: '',
    emailNF2: '',
  };
  form = this.formBuilder.group({
    endereco: [null, [Validators.required]],
    quantidade: [null, [Validators.required, Validators.min(1), Validators.max(100000)]],
    produto: [null, [Validators.required]],
  });
  form2 = this.formBuilder.group({
    dtPagamento: [this.form2DefaultValues.dtPagamento, [Validators.required]],
    enderecoFaturamento: [this.form2DefaultValues.enderecoFaturamento, [Validators.required]],
    contatoFaturamento: [this.form2DefaultValues.contatoFaturamento, [Validators.required]],
    emailConfirmacao: [this.form2DefaultValues.emailConfirmacao, [Validators.required]],
    emailNF: [this.form2DefaultValues.emailNF, [Validators.required]],
    emailNF2: [this.form2DefaultValues.emailNF2, [Validators.required]],
  });
  dataPagamento: any = null;
  prePago: boolean;
  dadosUltimoPedido: any;
  enderecoEntregaSelecionado: any;
  enderecoSemBeneficio = false;
  protected onDestroyComponent = new Subject<void>();
  filtroEndereco: UntypedFormControl = new UntypedFormControl('');
  filtroBeneficio: UntypedFormControl = new UntypedFormControl('');
  totalItens = 0;
  paginaAtual = 0;
  itensPorPagina = 7;
  listaProdutos: any = [];
  showAlertaExclusaoBeneficio = false;
  indexBeneficio: any;
  descricaoErro: any;
  showAlertDescartarAlteracoes: boolean = false;
  regexEmail = EMAIL_REGEX;

  constructor(
    private readonly fazerPedidoService: FazerPedidoService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly router: Router,
    private readonly windowRef: WindowReferenceService,
  ) {
    this.loadEnderecos();
    this.loadContatos();
  }

  ngOnInit(): void {
    this.prePago = !localStorage.getItem('tipoPagamentoEmpresa').includes('PÓS-PAGO - BOLETO COM REGISTRO');
    this.filtroEndereco.valueChanges
      .pipe(takeUntil(this.onDestroyComponent))
      .subscribe(() => {
        this.filtrarEnderecos();
      });
    this.filtroBeneficio.valueChanges
      .pipe(takeUntil(this.onDestroyComponent))
      .subscribe(() => {
        this.filtrarBeneficios();
      });
  }

  protected filtrarEnderecos() {
    if (!this.enderecosFaturamento) {
      return;
    }
    let busca = this.filtroEndereco.value;
    if (busca) {
      busca = busca.toLowerCase();
    } else {
      this.enderecosCadastrados.next(this.enderecosFaturamento.slice());
      return;
    }
    this.enderecosCadastrados.next(
      this.enderecosFaturamento.filter(endereco => endereco.descricaoReferencia.toLowerCase().includes(busca))
    );
  }

  protected filtrarBeneficios() {
    if (!this.beneficiosEncontrados) {
      return;
    }
    let buscaBeneficio = this.filtroBeneficio.value;
    if (buscaBeneficio) {
      buscaBeneficio = buscaBeneficio.toLowerCase();
    } else {
      this.produtosCadastrados.next(this.beneficiosEncontrados.slice());
      return;
    }
    this.produtosCadastrados.next(
      this.beneficiosEncontrados.filter(produto => produto.descricaoProduto.toLowerCase().includes(buscaBeneficio))
    );
  }

  loadEnderecos() {
    this.enderecosFaturamento = [];
    this.fazerPedidoService
      .getAllEnderecosFaturamento(this.idEmpresaLogada)
      .subscribe({
        next: ({response, status}: IServerResponse) => {
          if (status === 'OK') {
            this.enderecosFaturamento = response.map((endereco) => {
              let descricaoReferencia =
                `${endereco.descricaoLogradouro}, ${endereco.codigoNumero} - ${endereco.codigoBairro} - ${endereco.codigoCidade}/${endereco.codigoEstado} - ${endereco.codigoCep}`;
              descricaoReferencia = descricaoReferencia.toLowerCase();
              return {
                ...endereco,
                descricaoReferencia,
              };
            });
          }
          this.enderecosCadastrados.next(this.enderecosFaturamento);
          this.enderecosRecuperados = true;
        },
        error: (erro: any) => {
          console.error(erro);
        }
      });
  }

  loadBeneficios() {
    this.beneficiosEncontrados = [];
    this.loadingGenerico = true;
    this.fazerPedidoService.getAllBeneficiosByIdEndereco(this.idEndereco)
    .subscribe({
      next: ({response, status}: IServerResponse) => {
        if (status === 'OK') {
          this.beneficiosEncontrados = response.map((produtos) => {
            let descricaoProduto = `${produtos.descricaoProduto}`;
            descricaoProduto = descricaoProduto.toLowerCase();
            return {
              ...produtos,
              descricaoProduto,
            };
          });
          this.produtosCadastrados.next(this.beneficiosEncontrados);
          this.loadingGenerico = false;
        }
      },
      error: (erro: any) => {
        this.loadingGenerico = false;
        this.form.controls.endereco.setErrors({invalid: true});
        this.produtosCadastrados.next(this.beneficiosEncontrados);
        this.enderecoSemBeneficio = true;
        console.error(erro);
      }
    });
  }

  loadContatos() {
    this.contatosCadastrados = [];
    this.fazerPedidoService.getAllContatos(this.idEmpresaLogada).subscribe({
      next: ({response, status}: IServerResponse) => {
        if (status !== 'OK') {
          return;
        }
        this.contatosCadastrados = response;
      },
      error: (erro: any) => {
        console.error(erro);
      }
    });
  }

  adicionarBeneficio() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.listaBeneficios();
  }

  getValorPedido() {
    this.fazerPedidoService.getValorPedido(this.idEmpresaLogada, this.benefitList)
      .pipe()
      .subscribe({
        next: (res: IPedidoEstoquePapelResponse) => {
          if (res.status === 'OK') {
            this.resetaFormulario();
            this.listaProdutos.push(res.response);
            this.totalItens = res.response.produtos.length;
            this.idImportacao = res.response.idMongo;
          }
          if (res.status === 'NOK') {
            this.resetaFormulario();
            this.benefitList.pop();
            this.listaBeneficiosVerificacao.pop();
            this.showAlertErro = true;
            this.descricaoErro = 'Ocorreu um erro ao adicionar o benefício. Favor tentar novamente ou escolher outro benefício.';
          }
        },
        error: (erro: any) => {
          console.error(erro);
        }
      });
  }

  resetaFormulario() {
    this.form.reset();
    this.idProduto = 0;
    this.beneficiosEncontrados = [];
    this.produtosCadastrados.next(this.beneficiosEncontrados);
  }

  onItemDeleted(index) {
    this.showAlertaExclusaoBeneficio = true;
    this.indexBeneficio = index;
  }

  criarPedido(evento: any) {
    if (evento) {
      this.criarFormularioPedido();
      if (this.temErro === false) {
        this.loadingGenerico = true;
        this.alertConcluirPedido = false;
        this.fazerPedidoService.createPedidoAvulsoPapel(this.formData)
          .pipe(take(1)).subscribe({
            next: (res: any) => {
              this.detalhePedido = res.response;
              this.router.navigate(['/resumo-pedido-processado'],
                {state: {pedido: JSON.stringify(this.detalhePedido), isPrePago: this.prePago}});
            },
            error: (erro: any) => {
              console.error(erro);
            }
          });
      } else {
        this.formData = new FormData();
        this.alertConcluirPedido = false;
      }
    }
  }

  alertaPedido() {
    if (!this.prePago) {
      this.form2.get('dtPagamento').disable();
    }
    if (this.form2.invalid) {
      this.form2.markAllAsTouched();
      return;
    }
    if (this.idImportacao != null && this.listaProdutos.length) {
      this.alertConcluirPedido = true;
    } else {
      this.showAlertErro = true;
      this.descricaoErro = 'Nenhum benefício foi inserido!. Favor selecionar um benefício.';
      this.temErro = true;
    }
  }

  alertConcluirPedidoFechou(event: any) {
    this.alertConcluirPedido = event;
  }

  alertaErroFechou() {

    this.showAlertErro = false;
  }

  onClickContato() {
    this.getEmailContato();
    this.contatoSelecionadoError = false;
    this.form2.patchValue({
      idContato: this.contatoSelecionado
    });
  }

  getEmailContato() {
    if (this.contatoSelecionado != 0) {
      this.fazerPedidoService.getDadosContato(this.contatoSelecionado)
        .pipe(take(1))
        .subscribe({
          next: (resposta: any) => {
            this.emailConfirmacao = resposta.response.emailContato;
            this.onEmailConfirmacao();
          },
          error: (error: any) => {
            this.emailConfirmacao = '';
          }
        });
    }
    if (this.contatoSelecionado === 0) {
      this.emailConfirmacao = '';
    }
  }

  private criarFormularioPedido() {
    this.temErro = false;
    if (this.form2.value.enderecoFaturamento) {

      this.formData.append('idEndFaturamento', this.form2.value.enderecoFaturamento.idEndereco);
    } else {
      this.enderecoFaturamentoError = true;
      this.temErro = true;
    }
    if (this.form2.value.contatoFaturamento) {
      this.formData.append('contato', this.form2.value.contatoFaturamento.idContato);
    } else {
      this.contatoSelecionadoError = true;
      this.temErro = true;
    }
    if (this.prePago) {
      if (this.form2.value.dtPagamento) {
        this.formData.append('dtPgto', this.form2.value.dtPagamento.toISOString());
      } else {
        this.dataPagamentoError = true;
        this.dataPagamentoMessageError = 'Campo obrigatório';
        this.temErro = true;
      }
    }
    if (this.form2.value.emailConfirmacao) {
      this.formData.append('emailConf', this.form2.value.emailConfirmacao);
    } else {
      this.emailConfirmacaoError = true;
      this.temErro = true;
      this.campoEmailErrorMessage = 'Campo obrigatório';
    }
    if (this.form2.value.emailNF) {
      this.formData.append('emailNfe1', this.form2.value.emailNF);
    } else {
      this.emailNfError = true;
      this.temErro = true;
      this.campoEmailNfErrorMessage = 'Campo obrigatório';
    }
    if (this.form2.value.emailNF2) {
      this.formData.append('emailNfe2', this.form2.value.emailNF2);
    } else {
      this.emailNf2Error = true;
      this.temErro = true;
      this.campoEmailNf2ErrorMessage = 'Campo obrigatório';
    }
    this.formData.append('idImportacao', this.idImportacao);
    this.formData.append('idEmpresaPai', this.idEmpresaLogada);
  }

  listaBeneficios() {
    const obj = {
      prodDetalhe: [{
        idEndereco: this.form.value.endereco.idEndereco,
        quantidade: Number(this.form.value.quantidade),
        idProduto: this.idProduto,
      }],
    };
    const idVerificacao = {
      idVerificacao: JSON.parse(Object.assign((this.idProduto.toString()) + (this.form.value.endereco.idEndereco.toString())))
    };
    const index = this.listaBeneficiosVerificacao.findIndex(x => x.idVerificacao === idVerificacao.idVerificacao);
    if (index >= 0) {
      this.showAlertErro = true;
      this.descricaoErro = 'Benefício já inserido para o endereço selecionado. Favor selecionar outro benefício/endereço.';
    } else {
      this.listaProdutos = [];
      this.showAlertErro = false;
      this.listaBeneficiosVerificacao.push(idVerificacao);
      this.benefitList.push(obj);
      this.getValorPedido();
    }
  }

  onEmailConfirmacao() {
    this.emailConfirmacaoError = !this.regexEmail.test(this.emailConfirmacao);
    if (this.emailConfirmacaoError) {
      this.campoEmailErrorMessage = 'Formato de e-mail inválido';
      this.form2.controls.emailConfirmacao.setErrors({invalid: true});
    }
    if (!this.emailConfirmacao) {
      this.campoEmailErrorMessage = '';
      this.emailConfirmacaoError = false;
    }
  }

  onEmailNf() {
    this.emailNfError = !this.regexEmail.test(this.emailNf);
    this.campoEmailNfErrorMessage = 'Formato de e-mail inválido';
    if (this.emailNfError) {
      this.campoEmailNfErrorMessage = 'Formato de e-mail inválido';
      this.form2.controls.emailNF.setErrors({invalid: true});
    }
    if (!this.emailNf) {
      this.campoEmailNfErrorMessage = '';
      this.emailNfError = false;
    }
  }

  onEmailNf2() {
    this.emailNf2Error = !this.regexEmail.test(this.emailNf2);
    if (this.emailNf2Error) {
      this.campoEmailNf2ErrorMessage = 'Formato de e-mail inválido';
      this.form2.controls.emailNF2.setErrors({invalid: true});
    }
    if (!this.emailNf2) {
      this.campoEmailNf2ErrorMessage = '';
      this.emailNf2Error = false;
    }
  }

  onDataPagamento() {
    if (this.dataPagamento !== null) {
      // Caso a data de pagamento seja antes do dia da realização do pedido
      if (moment(this.form2.value.dtPagamento).add(1, 'day') < moment()) {
        this.dataPagamentoMessageError = 'Data deve ser maior ou igual a data atual';
        this.dataPagamentoError = true;
        this.form2.controls.dtPagamento.setErrors({invalid: true});
      }
      // Caso a data de pagamento seja maior que 30 dias a partir do dia da realização do pedido.
      else if (moment(this.form2.value.dtPagamento) >= moment().add(30, 'days')) {
        this.dataPagamentoMessageError = 'Data de Pagamento deve acontecer antes de 30 dias';
        this.dataPagamentoError = true;
        this.form2.controls.dtPagamento.setErrors({invalid: true});
      }
      // Em caso de não ocorrer nenhum dos casos acima
      else {
        this.dataPagamentoError = false;
        this.dataPagamentoMessageError = 'Data de Pagamento Inválida';
      }
    }
  }

  getInfoUltimoPedido() {
    this.fazerPedidoService.getInfoUltimoPedidoEmpresa(this.idEmpresaLogada)
      .pipe(take(1)).subscribe({
        next: (response: any) => {
          this.dadosUltimoPedido = response.response;
          this.emailConfirmacao = this.dadosUltimoPedido.emailContato;
          this.emailNf = this.dadosUltimoPedido.emailNf1;
          this.emailNf2 = this.dadosUltimoPedido.emailNf2;
          this.enderecoSelecionado = this.dadosUltimoPedido.enderecoFaturamento;
          this.form2.patchValue({idEnderecoFaturamento: this.dadosUltimoPedido.idEnderecoFaturamento});
          this.contatoSelecionado = this.dadosUltimoPedido.contatoFaturamento;
          this.form2.patchValue({idContato: this.dadosUltimoPedido.idContatoFaturamento});
        },
        error: (error: any) => {
          console.error(error);
        }
      });
  }

  onChangeEnderecoEntrega(enderecoSelecionado: any) {
    this.form.patchValue({
      endereco: enderecoSelecionado
    });
    this.form.markAsUntouched();
    this.form.controls.produto.setValue('');
    this.idProduto = 0;
    this.beneficiosEncontrados = [];
    this.idEndereco = enderecoSelecionado.idEndereco;
    this.enderecoSemBeneficio = false;
    this.loadBeneficios();
  }

  onChangeEnderecoFaturamento(enderecoSelecionado: any) {

    this.form2.patchValue({
      enderecoFaturamento: enderecoSelecionado
    });
    this.idEnderecoFaturamento = enderecoSelecionado.idEndereco;
  }

  onChangeProdutoSelecionado(produtoSelecionado: any) {
    this.idProduto = produtoSelecionado.idProduto;
  }

  itensPorPaginaAlterou(qtItems: any) {
    this.itensPorPagina = qtItems;
    this.getPaginaBeneficios(1);
  }

  getPaginaBeneficios(pagina: any) {
    this.paginaAtual = pagina;
  }

  exclusaoBeneficioFechou(retorno: any) {
    if (retorno >= 0) {
      this.benefitList.splice(retorno, 1);
      this.listaProdutos.splice(retorno, 1);
      this.listaBeneficiosVerificacao.splice(retorno, 1);
      if (this.benefitList.length) {
        this.listaProdutos = [];
        this.fazerPedidoService.getValorPedido(this.idEmpresaLogada, this.benefitList)
          .pipe(take(1))
          .subscribe({
            next: (res: IPedidoEstoquePapelResponse) => {
              if (res.status === 'OK') {
                this.listaProdutos.push(res.response);
                this.idImportacao = res.response.idMongo;
              }
              if (res.status === 'NOK') {
                this.idImportacao = null;
              }
            },
            error: (erro) => {
              console.error(erro);
            }
          });
      } else {
        this.listaProdutos = [];
      }
    }
    this.showAlertaExclusaoBeneficio = false;
    this.indexBeneficio = -1;
  }

  alertDescartarAlteracoes() {
    this.showAlertDescartarAlteracoes = true
  }

  cancelarPedido(retorno: any) {
    this.windowRef.reload();
  }

  fecharAlertDescartarAleracoes(retorno: any) {
    this.showAlertDescartarAlteracoes = false;
  }

  onChangeContatoFaturamento(contatoFaturamentoSelecionado: any) {
    this.form2.patchValue({
      contatoFaturamento: contatoFaturamentoSelecionado
    });
    this.idContatoFaturamento = contatoFaturamentoSelecionado.idContato;
  }
}
